import { render, staticRenderFns } from "./DocImage.vue?vue&type=template&id=2a6f1230&scoped=true&"
import script from "./DocImage.vue?vue&type=script&lang=js&"
export * from "./DocImage.vue?vue&type=script&lang=js&"
import style0 from "./DocImage.vue?vue&type=style&index=0&id=2a6f1230&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f1230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VProgressCircular,VRow})
